// src/components/CartDrawer.js
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { LanguageContext } from "../context/LanguageContext";
import { apiRequest } from "../services/api";

function CartDrawer() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const {
    isDrawerOpen,
    closeDrawer,
    cartItems,
    subtotal,
    discount,
    total,
  } = useCart();

  const t = {
    EN: {
      title: "Your Cart",
      viewCart: "View Full Cart",
      checkout: "Checkout",
      empty: "Your bag is empty.",
    },
    AR: {
      title: "سلة المشتريات",
      viewCart: "عرض السلة كاملة",
      checkout: "إتمام الشراء",
      empty: "سلتك فارغة.",
    },
  }[lang];

  const handleViewCart = () => {
  apiRequest("/analytics/track", {
    method: "POST",
    body: JSON.stringify({
      action_type: "open_cart_page",
      entity_type: "cart",
    }),
  }).catch(() => {});

  closeDrawer();
  navigate("/cart");
};


  return (
    <div
      className={`
        fixed inset-0 z-[9999]
        transition-opacity duration-300
        ${isDrawerOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}
      `}
    >
      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={closeDrawer}
      ></div>

      {/* PANEL */}
      <div
        className={`
          absolute top-0 right-0 h-full 
          w-[82%] sm:w-[380px] md:w-[420px]
          bg-white shadow-2xl
          transform transition-transform duration-300
          ${isDrawerOpen ? "translate-x-0" : "translate-x-full"}
        `}
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {/* HEADER */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#E6D8D2]">
          <h3 className="text-base font-semibold tracking-wide text-[#2E3135]">
            {t.title}
          </h3>
          <button
            onClick={closeDrawer}
            className="text-2xl text-[#7A7674] hover:text-black transition"
          >
            ×
          </button>
        </div>

        {/* CONTENT */}
        <div className="flex flex-col h-[calc(100%-60px)]">
          {/* ITEMS */}
          <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4">
            {cartItems.length === 0 && (
              <p className="text-sm text-[#7A7674] mt-8 text-center">
                {t.empty}
              </p>
            )}

            {cartItems.map((item) => (
              <div
                key={item.id}
                className="flex gap-3 border-b border-[#F0E6E1] pb-3"
              >
                <img
                  src={item.image}
                  alt={lang === "EN" ? item.nameEN : item.nameAR}
                  className="w-16 h-16 object-cover rounded-md bg-[#F2EFED]"
                />
                <div className="flex-1">
                  <p className="text-sm font-semibold text-[#2E3135]">
                    {lang === "EN" ? item.nameEN : item.nameAR}
                  </p>
                  <p className="text-xs text-[#7A7674] mt-1">
                    Qty: {item.qty}
                  </p>
                  <p className="text-sm font-bold mt-1">${item.price}</p>
                </div>
              </div>
            ))}
          </div>

          {/* SUMMARY + ACTIONS */}
          {cartItems.length > 0 && (
            <div className="border-t border-[#E6D8D2] px-5 py-4 space-y-2">
              <div className="flex justify-between text-sm">
                <span className="text-[#2E3135]">Subtotal</span>
                <span className="font-semibold">${subtotal}</span>
              </div>
              {discount > 0 && (
                <div className="flex justify-between text-xs text-[#7A7674]">
                  <span>Discount</span>
                  <span>- ${discount}</span>
                </div>
              )}
              <div className="flex justify-between text-sm font-semibold mt-1">
                <span>Total</span>
                <span>${total}</span>
              </div>

              <button
                onClick={handleViewCart}
                className="
                  w-full mt-3 py-2.5 bg-white border border-black 
                  text-black text-sm font-semibold rounded-md
                  hover:bg-black hover:text-white transition
                "
              >
                {t.viewCart}
              </button>

              <button
                onClick={() => {
  apiRequest("/analytics/track", {
    method: "POST",
    body: JSON.stringify({
      action_type: "enter_checkout",
      entity_type: "cart",
    }),
  }).catch(() => {});

  closeDrawer();
  navigate("/checkout");
}}

                 className="
                   w-full mt-2 py-2.5 bg-black text-white text-sm 
                   font-semibold rounded-md hover:bg-[#222] transition
                 "
               >
                 {t.checkout}
               </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CartDrawer;